import type { GetImpactRatingsResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetImpactRatingsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetImpactRatings = createQueryHook<
  Record<string, never>,
  GetImpactRatingsResponseRow[],
  GetImpactRatingsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.impactRating.impactRatings.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ impact_rating: data }),
  graphqlDocument: GetImpactRatingsDocument,
});
